import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState, useContext } from 'react'
import { classNames, ModalProps } from '../../utils/utils'
import { CancelIcon } from '../../utils/iconFactory'
import { useTheme } from '../../utils/themeUtils'
import { SearchInput } from '../Elements/CustomInputs'
import { TemplateCardRow } from '../TemplateComponents'
import { tabs, InnerGroupTypeList, isFeatureLocked } from "../../utils/state"
import { StateContext } from "../../services/context"

export default function SelectContentModal({ isVisible, onClose }: ModalProps) {
  const { user, setContentType } = useContext(StateContext)
  const { themeString } = useTheme()
  const [searchQuery, setSearchQuery] = useState<string>('');
    
  const filteredTabs = tabs
    .map((item) => {
      if (Array.isArray(item.groupData)) {
        return {
          ...item,
          groupData: item.groupData.filter(
            (actualItem) =>
              actualItem.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
              item.displayName.toLowerCase().includes(searchQuery.toLowerCase()) ||
              actualItem.description.toLowerCase().includes(searchQuery.toLowerCase())
          ),
        };
      } else {
        const filteredSubTests: InnerGroupTypeList = {};
        Object.keys(item.groupData).forEach((subTabKey) => {
          const subTestData = item.groupData as InnerGroupTypeList;
          const filteredSubTest = subTestData[subTabKey].filter(
            (actualItem) =>
              actualItem.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
              item.displayName.toLowerCase().includes(searchQuery.toLowerCase()) ||
              actualItem.description.toLowerCase().includes(searchQuery.toLowerCase())
          );
          if (filteredSubTest.length > 0) {
            filteredSubTests[subTabKey] = filteredSubTest;
          }
        });
  
        return {
          ...item,
          groupData: filteredSubTests,
        };
      }
    })
    .filter((item) => {
      if (Array.isArray(item.groupData)) {
        return item.groupData.length > 0;
      } else {
        return Object.keys(item.groupData).length > 0;
      }
    });

  return (
    <>
      <Transition appear show={isVisible} as={Fragment}>
        <Dialog as="div" className={classNames("relative z-40", themeString)} onClose={onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative h-[560px] w-[840px] rounded-[22px] bg-backgroundWhite py-8 text-left align-middle transform transition-all overflow-hidden">
                  <Dialog.Title
                    as="h3"
                    className="text-textMain text-style-h3 border-b border-gray10 pb-4 mx-8 overflow-hidden"
                  >
                    Válassz feladatot
                  </Dialog.Title>
                  <button className='absolute top-9 right-6' onClick={onClose}>
                    <CancelIcon className='h-6 w-6 text-gray100 fill-current' />
                  </button>

                  <div id='content' className="flex-col max-h-full px-8 pt-6 overflow-y-auto">
                    <p className="text-textMain text-style-body2">Kattints arra a feladatra, melyet el szeretnél végeztetni AIDA-val.</p>
                    <div className='pt-[22px]'>
                      <SearchInput
                        type="text"
                        value={searchQuery}
                        customAction={() => setSearchQuery("")}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Keresés..."
                        spellCheck={false}
                      />
                    </div>
                    <div id='template-card-section' className="pt-[26px] flex flex-col max-h-full w-full" >
                      {filteredTabs.map((item, index) => (
                        <TemplateCardRow
                          index={index}
                          item={item}
                          setContentType={setContentType}
                          onClick={onClose}
                          isLocked={isFeatureLocked(user.plan, item.componentName)}
                        />
                      ))}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
